class CfopIcmsController extends AbstractCrudController

  configure: (configs) ->
    configs.model = 'cfopIcms'
    configs.module = 'eficiencia-fiscal'
    configs.folder = 'configuracao/icms/cfop-icms'
    configs.itemName = (item) -> "o CFOP ICMS Nº <strong>#{item.id}</strong>"

    @setModal('modalImportar', 'importar', 'cfopIcmsImportarController')
    @setModal('modalCfopIcms', 'modal', 'cfopIcmsModalController')

  initialize: ->
    @inject('estadoService')
    @inject('cstIcmsService')
    @inject('$filter')

    @listOfEstado = []
    @estadoService.getList (list) =>
      @listOfEstado = list

    @listOfCstIcms = []
    @cstIcmsService.getList (result) =>
      if result.success
        @listOfCstIcms = result.data.items
      else
        @Alert.error('Ocorreu um erro ao buscar lista de CST.', 'Erro!', false)

  importar: ->
    @modalImportar(@modalResolve(), (result) => @loadData() if result.ok)

  baixar: ->
    cbk.download '/api/eficiencia-fiscal/cfop-icms.csv'

  modalResolve: (cfopIcms = {}) ->
    if !cfopIcms.id
      cfopIcms =
        cfopsSaida: []
        cstsPermitidas: []

    {
      cfopIcms: => angular.copy(cfopIcms)
      listOfEstado: => angular.copy(@listOfEstado)
      listOfCstIcms: => angular.copy(@listOfCstIcms)
    }

angular.module('eficienciaFiscalModule').controller('cfopIcmsController', CfopIcmsController)

class CfopIcmsModalController extends AbstractController
  @$inject = ['$injector', '$scope', '$filter', '$uibModalInstance', 'cfopIcmsService', 'cfopIcms', 'listOfEstado',
    'listOfCstIcms']

  constructor: ($injector, scope, @filter, @modalInstance, @cfopIcmsService, @cfopIcms, @listOfEstado, @listOfCstIcms) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @uiSelectListOfCstIcms = @listOfCstIcms
    scope.$watch (=> @cfopIcms.estado), (newEstado, oldEstado) =>
      @cfopIcms.cstsPermitidas = [] if newEstado?.id != oldEstado?.id

      if @cfopIcms.estado
        @uiSelectListOfCstIcms = @filter('filter')(@listOfCstIcms, (item) =>
          item.estado.id == (@cfopIcms.estado.id or @cfopIcms.estado)
        )

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @cfopIcmsService.save(@cfopIcms, (data) =>
        Alert.success("CFOP ICMS Nº <strong>#{data.id}</strong> #{if @cfopIcms.id then 'atualizado' else 'criado'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

angular.module('eficienciaFiscalModule').controller('cfopIcmsModalController', CfopIcmsModalController)

class CfopIcmsImportarController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'FileUploader']

  constructor: ($injector, @modalInstance, FileUploader) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @url = "/api/eficiencia-fiscal/cfop-icms"

    @uploader = new FileUploader(
      url: @url
      headers: cbk.getHeaders()
    )

    @uploader.onBeforeUploadItem = (item) =>
      return item

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      if response.success
        @Alert.success("O CSV de CFOPs ICMS foi importado com sucesso.", 'Sucesso')
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        @Alert.warning('Ocorreu um erro ao realizar a importação.', 'Operação não realizada', false)

  importar: () ->
    @uploader.uploadAll()

angular.module('eficienciaFiscalModule').controller('cfopIcmsImportarController', CfopIcmsImportarController)